import React from "react";

import ManipulationBaseObject from "wprr/manipulation/ManipulationBaseObject";

//import ContentCreatorSingleItem from "wprr/elements/create/ContentCreatorSingleItem";
export default class ContentCreatorSingleItem extends ManipulationBaseObject {

	constructor(aProps) {
		super(aProps);
	}
	
	_removeUsedProps(aReturnObject) {
		let returnObject = super._removeUsedProps(aReturnObject);
		
		delete returnObject["data"];
		delete returnObject["contentCreator"];
		
		return returnObject;
	}
	
	_getChildrenToClone() {
		
		let data = this.getSourcedProp("data");
		let contentCreator = this.getSourcedProp("contentCreator");
		
		if(!contentCreator) {
			console.error("Content creator is not set.", this);
			return React.createElement("div", {}, "Content creator is not set");
		}
		
		if(!data) {
			data = {"children": this.props.children};
		}
		
		let returnArray = new Array();
		contentCreator(data, 0, this.getReferences(), returnArray);
		
		if(returnArray.length === 0) {
			console.error("Content creator didn't return any node.", this);
			return [React.createElement("div", {}, "Content creator did not return any object")];
		}
		
		return returnArray;
	}
}
